import { render, staticRenderFns } from "./ShippingCost.vue?vue&type=template&id=2b5654c1&scoped=true"
import script from "./ShippingCost.vue?vue&type=script&lang=js"
export * from "./ShippingCost.vue?vue&type=script&lang=js"
import style0 from "./ShippingCost.vue?vue&type=style&index=0&id=2b5654c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5654c1",
  null
  
)

export default component.exports